import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import styled from 'styled-components'

interface Props {
  open: boolean
  title: string
  description: string
  imageAlt?: string
  imageSrc?: string
  primaryActionLabel: string
  onPrimaryAction: () => void
  onClose: () => void
  secondaryActionLabel?: string
  onSecondaryAction?: () => void
}

export default function CourseGpsEditorGreenAutoMapDialog({
  open,
  title,
  description,
  imageAlt,
  imageSrc,
  primaryActionLabel,
  onPrimaryAction,
  onClose,
  secondaryActionLabel,
  onSecondaryAction,
}: Props): JSX.Element {
  return (
    <StyledDialog open={open} onClose={onClose} hideBackdrop>
      <StyledDialogContent>
        <Title>{title}</Title>
        <ContentText>{description}</ContentText>
        {imageSrc && <DialogImage src={imageSrc} alt={imageAlt || title} />}
      </StyledDialogContent>
      <StyledDialogActions>
        {secondaryActionLabel && onSecondaryAction && (
          <SecondaryButton onClick={onSecondaryAction}>{secondaryActionLabel}</SecondaryButton>
        )}
        <PrimaryButton onClick={onPrimaryAction}>{primaryActionLabel}</PrimaryButton>
      </StyledDialogActions>
    </StyledDialog>
  )
}

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    width: min(328px, calc(100vw - 32px));
    border-radius: 16px;
    border-top: 0.5px solid rgba(255, 255, 255, 0.15);
    border-bottom: 0.5px solid rgba(255, 255, 255, 0.15);
    background: rgba(20, 24, 26, 0.7);
    backdrop-filter: blur(5px);
    color: #fff;
  }
`

const StyledDialogContent = styled(DialogContent)`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: center;
`

const StyledDialogActions = styled(DialogActions)`
  justify-content: space-between;
  gap: 12px;
`

const Title = styled.h2`
  margin: 0;
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
`

const ContentText = styled(DialogContentText)`
  margin: 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
`

const DialogImage = styled.img`
  display: block;
  width: 100%;
  border-radius: 12px;
  object-fit: cover;
`

const DialogButton = styled(Button)`
  height: 34px;
  border-radius: 12px;
  text-transform: none;
  font-size: 16px;
  font-weight: 500;
  padding: 8px 16px;
  min-width: unset;
`

const PrimaryButton = styled(DialogButton)`
  background: transparent;
  color: #fff;
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`

const SecondaryButton = styled(DialogButton)`
  background: transparent;
  color: rgba(255, 255, 255, 0.7);

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`
